import React from 'react';
import Typography, { StyledTypographyProps } from '.';

const Subtitle2 = (props: StyledTypographyProps) => {
	return <Typography variant='subtitle2' color='textSecondary' {...props} />;
};

export default Subtitle2;
